var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorPaletteFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.125 21.212A9.676 9.676 0 0012 22c.75 0 1.354-.2 1.813-.6.458-.4.687-1.017.687-1.85 0-.483-.125-.913-.375-1.288s-.375-.662-.375-.862c0-.1.03-.192.088-.275.058-.083.162-.125.312-.125H16c1.667 0 3.083-.512 4.25-1.537C21.417 14.438 22 12.966 22 11.05c0-1.283-.262-2.48-.788-3.588a9.092 9.092 0 00-2.125-2.874 9.918 9.918 0 00-3.112-1.9A10.36 10.36 0 0012.2 2c-1.4 0-2.717.263-3.95.788a10.48 10.48 0 00-3.237 2.137 10.13 10.13 0 00-2.2 3.175A9.48 9.48 0 002 12c0 1.367.263 2.658.788 3.875a10.142 10.142 0 002.15 3.188c.908.908 1.97 1.625 3.187 2.15zM16 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM9.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 11.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm9.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorPaletteFill);
export default __webpack_public_path__ + "13b09106cc280133882ad04cb851863a.svg";
export { ForwardRef as ReactComponent };